import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  // Function to scroll to top when link is clicked
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // This adds smooth scrolling animation
    });
  };

  return (
    <footer className="footer">
      <div className="container">
        {/* Main Footer Content */}
        <div className="footer-main">
          {/* Brand Section - Your Identity */}
          <div className="footer-brand">
            <h2 className="brand-name">Masai<span>Link</span></h2>
            <p className="brand-tagline">Your Link to Masai Quality</p>
            <div className="brand-badge">
              <span className="badge">✓ Authorized Distributor</span>
            </div>
            <div className="contact-card">
              <div className="contact-item">
                <span className="contact-icon">📱</span>
                <div>
                  <span className="contact-label">Call Us</span>
                  <a href="tel:0115016167" className="contact-value">0115 016 167</a>
                </div>
              </div>
              <div className="contact-item">
                <span className="contact-icon">✉️</span>
                <div>
                  <span className="contact-label">Email</span>
                  <a href="mailto:masailink@masaigroup.co.ke" className="contact-value">masailink@masaigroup.co.ke</a>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/" onClick={scrollToTop}>Home</Link></li>
              <li><Link to="/cables" onClick={scrollToTop}>Masai Cables</Link></li>
              <li><Link to="/pumps" onClick={scrollToTop}>Versil Pumps</Link></li>
              <li><Link to="/steel" onClick={scrollToTop}>Masai Steel</Link></li>
              <li><Link to="/quote" onClick={scrollToTop}>Request Quote</Link></li>
              <li><Link to="/about" onClick={scrollToTop}>About Us</Link></li>
              <li><Link to="/contact" onClick={scrollToTop}>Contact Us</Link></li>
            </ul>
          </div>

          {/* Catalogues */}
          <div className="footer-links">
            <h3>Catalogues</h3>
            <ul>
              <li><Link to="/catalogue" onClick={scrollToTop}>📋 Cable Catalogue</Link></li>
              <li><Link to="/pump-catalogue" onClick={scrollToTop}>💧 Pump Catalogue</Link></li>
              <li><Link to="/steel-catalogue" onClick={scrollToTop}>🔩 Steel Catalogue</Link></li>
            </ul>
            <div className="products-we-supply">
              <h4>We Supply:</h4>
              <div className="product-tags">
                <span className="product-tag">⚡ Masai Cables</span>
                <span className="product-tag">💧 Versil Pumps</span>
                <span className="product-tag">🔩 Masai Steel</span>
              </div>
            </div>
          </div>

          {/* Locations & Hours */}
          <div className="footer-locations">
            <h3>Our Locations</h3>
            <div className="location-card">
              <span className="location-icon">📍</span>
              <div>
                <strong>Kitengela Office</strong>
                <p>P.O. Box 344 - 00242<br />Off Mombasa Road</p>
              </div>
            </div>
            <div className="location-card">
              <span className="location-icon">🏢</span>
              <div>
                <strong>Nairobi Office</strong>
                <p>Industrial Area<br />(By appointment)</p>
              </div>
            </div>
            <div className="hours-card">
              <span className="hours-icon">⏰</span>
              <div>
                <strong>Business Hours</strong>
                <p>Mon-Fri: 8:00am - 5:00pm<br />Sat: 9:00am - 1:00pm</p>
              </div>
            </div>
          </div>
        </div>

        {/* Middle Bar - Quick Actions & Social */}
        <div className="footer-middle">
          <div className="quick-actions">
            <a href="tel:0115016167" className="action-btn call">
              <span>📞</span> Call Now
            </a>
            <a href="https://wa.me/254115016167" className="action-btn whatsapp">
              <span>💬</span> WhatsApp
            </a>
            <a href="mailto:masailink@masaigroup.co.ke" className="action-btn email">
              <span>✉️</span> Send Email
            </a>
          </div>

          <div className="social-section">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link">📘</a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">🐦</a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">📷</a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link">🔗</a>
          </div>

          <div className="qr-mini">
            <div className="qr-placeholder-small">QR</div>
            <span>Scan for catalogue</span>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} MasaiLink. All rights reserved.</p>
          <p className="disclaimer">Authorized distributor of Masai Cables, Versil Pumps & Masai Rolling Mills</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;